export interface ProjectWorkflowStatusOutputModel extends  ProjectWorkflowModel {
    businessGroup: string,
    statusDescription: string,
    statusTypeDesc: string,
}
export interface ProjectWorkflowStatusInputModel extends  ProjectWorkflowModel  {
    member_Id: number,
}

export type ProjectWorkflowModel=
{
    status_Id: number|null,
    status_Type: number|null,
    status_Order: number,
    projectStatusDesc: string,
    sCurveStatusDesc: string,
    isActive: boolean,
    project_Id  : number,
    group_Id    : number,
    insertFlag :boolean
}

export interface INumberViewModel {
    project_Id: number,
    group_Id: number,
    module_Id: number,
    module_Name: string,
    sl_No_Length: number,
    is_Active: boolean
  }
  export interface INumberInputModel{ 
    project_Id: number,
	group_Id: number,
	module_Id:number,
	sl_No_Length: number,
	userId :number,
	input_Type :string,
    is_Active : boolean
}